import { COLOR } from '@cosuno/cosuno-ui';
import React from 'react';

import {
  Card,
  CardWrapper,
  FeaturesItemsList,
  FeaturesSection,
  FeaturesTitle,
  HighlightTag,
  PackageDescription,
  PackageTitle,
  Section,
} from './Styles';

interface Props {
  item: string;
  color: COLOR;
  isHighlighted: boolean;
  highlightTagText: string;
  packageTitle: string;
  packageTag?: React.ReactNode;
  packageDescription: string;
  featuresTitle?: string;
  featuresItems: string[];
  actionButton: React.ReactNode;
}

export const PricingItemCard: React.FC<Props> = ({
  item,
  color,
  isHighlighted,
  highlightTagText,
  packageTitle,
  packageTag,
  packageDescription,
  featuresTitle,
  featuresItems,
  actionButton,
}) => (
  <CardWrapper data-cy-pricing-item={item} $borderColor={color} $isHighlighted={isHighlighted}>
    {isHighlighted && (
      <HighlightTag data-cy-pricing-item-recommended $background={color} color={COLOR.white}>
        {highlightTagText}
      </HighlightTag>
    )}
    <Card>
      <Section>
        <PackageTitle $color={color}>
          {packageTitle}
          {packageTag}
        </PackageTitle>
        <PackageDescription>{packageDescription}</PackageDescription>
      </Section>
      <FeaturesSection>
        {featuresTitle && <FeaturesTitle>{featuresTitle}</FeaturesTitle>}
        <FeaturesItemsList>
          {featuresItems.map((featureItem, index) => (
            <li key={index}>{featureItem}</li>
          ))}
        </FeaturesItemsList>
      </FeaturesSection>
      {actionButton}
    </Card>
  </CardWrapper>
);
